import React, { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import "../../config/i18n";
import { NavLink } from "react-router-dom";
import axios from "axios";
import Loader from "react-loader-spinner";
import ZipCodeInput from "../welcome/ZipCodeInput";
import AlertBox from "../Utills/AlertBox";

class ReqBracelet extends Component {
  constructor(props) {
    super(props);
    this.handleActiveBracelet = this.handleActiveBracelet.bind(this);
    this.requestBracelet = this.requestBracelet.bind(this);
    this.getUserBracelet = this.getUserBracelet.bind(this);
    this.verifyPayment = this.verifyPayment.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.validateAddress=this.validateAddress.bind(this)
    this.handleZipChange=this.handleZipChange.bind(this)
    this.state = {
      activeBracelet: 0,
      Bracelets: [],
      api_url: localStorage.getItem("api_url"),
      user_id: JSON.parse(localStorage.getItem("session_userid")),
      alertOptions:{
        alert:false,
        head:"Bracelet Request",
        success:true,
        message:"Kindly press okay to proceed further with the request",
        action:this.validateAddress.bind(this)
      },
      zip:"",
      userBracelets: {
        address: "",
        apart: "",
        city: "",
        state: "Florida",
        country: "USA",
        zip_code: "",
      },
      invalidAddress: false,
      originalData: {
        address: "",
        apart: "",
        city: "",
        state: "",
        country: "",
        zip_code: "",
      },

      braceletError: "",
      TransactionToken: localStorage.getItem("trans_id"),
      loader: "",
      media_url: localStorage.getItem("media_url"),
    };
  }
  verifyPayment() {
    axios
      .get(this.state.api_url + `verifyPayment/` + this.state.user_id)
      .then((res) => {
        if (res.data.status != "false") {
          const address_details = JSON.parse(
            localStorage.getItem("address_details")
          );
          var reqDetails = new FormData();
          reqDetails.set("user_id", this.state.user_id);
          reqDetails.set("bracelet_id", res.data.braceletId);

          if (address_details != null) {
            reqDetails.set("address", address_details.address);
            reqDetails.set("apartment", address_details.apart);
            reqDetails.set("city", address_details.city);
            reqDetails.set("state", address_details.state);
            reqDetails.set("country", address_details.country);
            reqDetails.set("postal", address_details.zip_code);
          }

          axios({
            method: "post",
            url: this.state.api_url + "reqBracelet",
            data: reqDetails,
            config: { headers: { "Content-Type": "multipart/form-data" } },
          }).then((res) => {
            if (res.data.status) {
              const address_details = JSON.parse(
                localStorage.getItem("address_details")
              );
              address_details.req_status = 1;

              localStorage.setItem(
                "address_details",
                JSON.stringify(address_details)
              );
              this.setState(
                {
                  braceletError: "your request has been sent",
                },
                () => {
                  setTimeout(() => {
                    this.setState({
                      braceletError: "",
                    });
                  }, 3000);
                }
              );
              this.getUserBracelet();
            }
          });
        }
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      userBracelets: {
        ...prevState.userBracelets,
        [name]: value,
      },
    }));
  }

  handleZipChange(e) {
    let value = e.target.value.replace(/[^0-9]/g, '');
    let result = '';

    if (value.length <= 5) {
        result = value;
    } else if (value.length > 5) {
        // Insert the hyphen after the first five digits
        let former = value.slice(0, 5);
        let later = value.slice(5); // Get the remaining part
        result = former + '-' + later;
    }

    this.setState({
        userBracelets: {
            address: this.state.userBracelets.address,
            apart: this.state.userBracelets.apart,
            city: this.state.userBracelets.city,
            state: this.state.userBracelets.state,
            country: this.state.userBracelets.country,
            zip_code: result,
        },
    });
}

  getUserBracelet() {
    axios
      .get(this.state.api_url + `getUserBracelets/` + this.state.user_id.trim())
      .then((res) => {
        if (res.data.status) {
          console.log(res.data.result);
          this.setState({
            userBracelets: res.data.result,
            activeBracelet: res.data.result.bracelet_id,
            originalData: res.data.result,
            zip:res.data.result.zip_code
          });
        }
      });
  }
  componentDidMount() {
    this.setState({
      loader: "loder-icon",
    });
    // setTimeout(() => {
    //     this.setState({
    //         profilespace: '',
    //         loader: 'none'
    //     });
    //   }, 1000);

    axios.get(this.state.api_url + `getAllBracelets`).then((res) => {
      if (res.data.status) {
        this.setState({ Bracelets: res.data.result, loader: "none" });
      } else {
        console.log("error");
      }
    });
    console.log(this.state.user_id);
    this.getUserBracelet();
    const address_details = JSON.parse(localStorage.getItem("address_details"));

    this.verifyPayment();
  }
  handleActiveBracelet(id) {
    if (this.state.userBracelets.req_status) {
      this.setState({
        activeBracelet: id,
      });
    }
  }

  validateAddress(){
    const api_url = localStorage.getItem("api_url");

    const formData = new FormData();
    formData.set("address", this.state.userBracelets.address);
    formData.set("apartment", this.state.userBracelets.apart);
    formData.set("city", this.state.userBracelets.city);
    formData.set("state", this.state.userBracelets.state);
    formData.set("country", this.state.userBracelets.country);
    formData.set("postal_code", this.state.userBracelets.zip_code);

    axios({
      method: "post",
      url: api_url + "validateaddress",
      data: formData,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    }).then((res) => {
      const response = res.data;
      if (response.status != true) {
        this.setState(
          {
            invalidAddress: true,
          },
          () => {
            setTimeout(() => {
              this.setState({
                invalidAddress: false,
              });
            }, 3000);
          }
        );
      } else {
       
        localStorage.setItem(
          "bracelet_id",
          JSON.stringify(this.state.activeBracelet)
        );
        localStorage.setItem(
          "address_details",
          JSON.stringify(this.state.userBracelets)
        );

        this.props.history.push("/app/BraceletPayment");
      }
    });
  }

  requestBracelet(e) {
    e.preventDefault();

    const address_details = JSON.parse(localStorage.getItem("address_details"));

    if (
      this.state.activeBracelet != this.state.userBracelets.bracelet_id ||
      this.state.originalData.address != this.state.userBracelets.address ||
      this.state.originalData.apart != this.state.userBracelets.apart ||
      this.state.originalData.city != this.state.userBracelets.city ||
      this.state.originalData.state != this.state.userBracelets.state ||
      this.state.originalData.country != this.state.userBracelets.country ||
      this.state.originalData.zip_code != this.state.userBracelets.zip_code
    ) {
     this.validateAddress()
    } else {
      this.setState({
        alertOptions:{
          alert:true,
          head:"Bracelet Request",
          message:"Please click yes to proceed further with the bracelet request",
          success:true,
          action:this.validateAddress.bind(this)
        }
      })
    }
  }

  render() {
    const style = {
      zIndex: 10,
      backgroundColor: "white",
      height: "80vh",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      //width:"100%",
      overflowY: "hidden",
    };
    return (
      <>
        {this.state.loader != "none" ? (
          <div className={this.state.loader}>
            <div style={style} id="loader">
              <Loader type="Bars" color="#32A5D2" height={30} width={50} />
            </div>
          </div>
        ) : (
          <div className="edit-profile-page">
            <div className="d-flex profile-header-top stickyProfileHead justify-content-between apd15 apr0 apl0 white-bg amb10 ">
              <div class="heading-left-top d-flex">
                <div className="align-self-center ">
                  <NavLink to="/app/Profile">
                    <div className="iconHolder align-self-center mr-1">
                      <div className="backGlow">
                        <div className="backIco"></div>
                      </div>
                    </div>
                  </NavLink>
                </div>
                <span class="arrow-center align-self-center bold-font">
                  <Trans i18nKey="Change or Ask for a bracelet">
                    Change or Ask for a bracelet{" "}
                  </Trans>
                </span>
              </div>
            </div>

            <div className="">
              <div className="d-flex justify-content-center">
                <div className="edit-profile-width white-bg amt20 amb20">
                  <form
                    className="apd20 req-form"
                    onSubmit={this.requestBracelet}
                  >
                    <h4 className="bracelet-head">
                      <Trans i18nKey="Select Bracelet type">
                        Select Bracelet type
                      </Trans>
                    </h4>
                    {this.state.userBracelets.req_status ? (
                      ""
                    ) : (
                      <span>Waiting for admin approval </span>
                    )}
                    <div className="bracelet-type-container req-page">
                      {this.state.Bracelets &&
                        this.state.Bracelets.map((bracelet) => {
                          return (
                            <div
                              className={
                                "bracelet-type" +
                                (this.state.activeBracelet ==
                                bracelet.bracelet_id
                                  ? " active-bracelet-type"
                                  : "")
                              }
                              onClick={() => {
                                this.handleActiveBracelet(bracelet.bracelet_id);
                              }}
                            >
                              <div className="letter">
                                <img
                                  src={
                                    `${this.state.media_url}/uploads/` +
                                    bracelet.bracelet_icon
                                  }
                                  className="letter_image"
                                />
                              </div>
                              <label className="brc-txt1">
                                {bracelet.bracelet_name}
                              </label>
                              <label className="brc-txt2">
                                {bracelet.bracelet_desc.length > 14
                                  ? bracelet.bracelet_desc.slice(0, 12)
                                  : bracelet.bracelet_desc}
                                {bracelet.bracelet_desc.length > 14 && "..."}
                              </label>
                            </div>
                          );
                        })}
                    </div>

                    <h5 className="brc-title brc-title2">
                      <Trans i18nKey="Delivery Address">
                        {" "}
                        Delivery address
                      </Trans>{" "}
                    </h5>

                    {/* <div className="user-input-wrp amb25">
    <br />
    <input type="text" id="name" value={this.state.name} onChange={this.onChangeName} maxLength={20} minLength={3} onKeyPress={(e) => this.restrict(e)} className="inputText" placeholder=" " required />
    <span className="floating-label"><Trans i18nKey="Name">Name</Trans></span>
</div> */}
                    <div className="user-input-wrp amb25">
                      <br />
                      <input
                        className="inputText inputText1"
                        type="text"
                        id="name"
                        name="address"
                        value={this.state.userBracelets.address}
                        required
                        maxLength={60}
                        minLength={3}
                        onChange={(e) => this.handleChange(e)}
                      />
                      <span className="floating-label floating-label-font">
                        <Trans i18nKey="Address">Address</Trans>
                      </span>
                    </div>

                    <div className="user-input-wrp amb25">
                      <br />
                      <input
                        className="inputText inputText1"
                        type="text"
                        id="name"
                        name="apart"
                        value={this.state.userBracelets.apart}
                        required
                        maxLength={60}
                        minLength={3}
                        onChange={(e) => this.handleChange(e)}
                      />
                      <span className="floating-label floating-label-font">
                        <Trans i18nKey="Apartment, Suite, etc.">Apartment,Suite etc</Trans>
                      </span>
                    </div>

                    <div className="user-input-wrp amb25">
                      <br />
                      <input
                        className="inputText inputText1"
                        type="text"
                        id="name"
                        name="city"
                        value={this.state.userBracelets.city}
                        required
                        maxLength={60}
                        minLength={3}
                        onChange={(e) => this.handleChange(e)}
                      />
                      <span className="floating-label floating-label-font">
                        <Trans i18nKey="City">City</Trans>
                      </span>
                    </div>

                    <div className="user-input-wrp amb25">
                      <br />
                      <input
                        className="inputText inputText1"
                        type="text"
                        id="name"
                        name="state"
                        value={this.state.userBracelets.state}
                        required
                        maxLength={60}
                        minLength={3}
                        onChange={(e) => this.handleChange(e)}
                        disabled
                      />
                      <span className="floating-label floating-label-font">
                        <Trans i18nKey="State/Province">State/Province</Trans>
                      </span>
                    </div>

                    <div className="user-input-wrp amb25">
                      <br />
                      <input
                        className="inputText inputText1"
                        type="text"
                        id="name"
                        name="country"
                        value={this.state.userBracelets.country}
                        required
                        maxLength={60}
                        minLength={3}
                        onChange={(e) => this.handleChange(e)}
                        disabled={true}
                      />
                      <span className="floating-label floating-label-font">
                        <Trans i18nKey="Country">Country</Trans>
                      </span>
                    </div>

                    <div className="user-input-wrp amb25">
                      <br />
                      <input
                        className="inputText inputText1"
                        type="text"
                        id="name"
                        name="zip_code"
                        value={this.state.userBracelets.zip_code}
                        required
                        maxLength={10}
                        minLength={3}
                        onChange={(e) => this.handleZipChange(e)}
                      />
                      <span className="floating-label floating-label-font">
                        <Trans i18nKey="Zip code">ZipCode</Trans>
                      </span>
                    </div>

                    {/* <div className="user-input-wrp amb25">
                      <input
                        className="inputText inputText1"
                        type="text"
                        id="name"
                        name="zip_code"
                        value={this.state.userBracelets.zip_code}
                        required
                        maxLength={10}
                        minLength={3}
                        onChange={(e) => this.handleZipChange(e)}
                      />
                      <span className="floating-label floating-label-font">
                        <Trans i18nKey="Address">Zip code</Trans>
                      </span>
                    
                    </div> */}
                    {this.state.invalidAddress ? (
                      <p
                        style={{
                          color: "red",
                          textAlign: "center",
                        }}
                      >
                        Please Enter a Valid address
                      </p>
                    ) : null}
                    {this.state.userBracelets.req_status == 1 ? (
                      <div className="form-group">
                        <div className="premium amt15 amb15">
                          <button type="submit" className="btn btn-bg width100">
                            {" "}
                            <Trans i18nKey="Request Bracelet">
                              Request Bracelet
                            </Trans>{" "}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="form-group">
                        <div className="premium amt15 amb15">
                          <button
                            type="submit"
                            className="btn btn-bg width100 btn-disable"
                            disabled
                          >
                            {" "}
                            <Trans i18nKey="Request Bracelet">
                              Request Bracelet
                            </Trans>{" "}
                          </button>
                        </div>
                      </div>
                    )}

                    {this.state.braceletError && (
                      <div className="req-toaster">
                        {this.state.braceletError}
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
        <AlertBox options={this.state.alertOptions}/>
      </>
    );
  }
}

export default ReqBracelet;
